import { Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import Dashboard from './pages/Dashboard';
import GoalEditor from './pages/GoalEditor';
import ProgressDetail from './pages/ProgressDetail';
import Settings from './pages/Settings';
import PublicCoachView from './pages/PublicCoachView';
import BottomNav from './components/BottomNav';

function App() {
  const userId = localStorage.getItem('userId');

  return (
    <div className="min-h-screen bg-slate-900 text-white max-w-lg mx-auto relative">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/user/:userId/*" element={<AuthenticatedLayout />} />
        <Route path="/view/:shareId" element={<PublicCoachView />} />
        <Route path="*" element={<Navigate to={userId ? `/user/${userId}` : '/'} replace />} />
      </Routes>
    </div>
  );
}

function AuthenticatedLayout() {
  return (
    <>
      <div className="pb-24">
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/goal/:goalId?" element={<GoalEditor />} />
          <Route path="/goal/:goalId/progress" element={<ProgressDetail />} />
          <Route path="/settings" element={<Settings />} />
        </Routes>
      </div>
      <BottomNav />
    </>
  );
}

export default App;
